import { Progress } from 'modules/types'
import { Dict } from 'types/generics'
import { AddError, EntityMetadata, FetchError, RemoveError, UpdateError } from 'modules/domain/types'
import { UserDTO } from 'modules/domain/user/types'
import { AssetType, DigitalAssetDocumentType, DigitalAssetFileSize, Status, UploadCompanyType } from 'types/entities'

export type DigitalAssetListRequestFilter = {
  company_id?: string | string[]
  document_type?: DigitalAssetDocumentType | DigitalAssetDocumentType[]
  search?: string
  start_date?: string
  end_date?: string
  size?: DigitalAssetFileSize | DigitalAssetFileSize[]
  uploaded_by_company_type?: UploadCompanyType
  status?: Status | Status[]
}

export enum DigitalAssetStatusUpdateAction {
  soft_delete = 'soft_delete',
  restore = 'restore',
}

export type DigitalAssetStatusUpdateRequest = {
  action: DigitalAssetStatusUpdateAction
  digital_asset_ids: string[]
}

export type DigitalAssetDeleteRequest = {
  digital_asset_ids: string[]
}

export type DigitalAsset = {
  id: string
  metadata?: DigitalAssetMetaData
  document_type?: DigitalAssetDocumentType
  asset_type?: AssetType
  document_name?: string
  asset_name?: string
  link_url?: string
  description?: string
  location?: string
  create_company_id?: string
  create_user_id?: string
  uploaded_by_company_type: UploadCompanyType
  created_at: string
  status?: Status
  linked_companies?: LinkedCompany[]
  file_size?: number
  company_name?: string
  user_name?: string
}

export type DigitalAssetMetaData = {
  created_at: string
  updated_at: string
  obj_id: string
  author: string
  updated_by: string
  updated_by_user: UserDTO
  created_by_user: UserDTO
}

export type LinkedCompany = {
  id: string
  name: string
  province?: string
}

export type DigitalAssetListRequestSorting = {
  sort_field?: keyof DigitalAsset
  sort_reversed?: boolean
}

export type DigitalAssetDTO = Omit<DigitalAsset, 'id' | 'created_at'>

export type DigitalAssetEditDTO = DigitalAsset & {
  add_company_ids?: string[]
  remove_company_ids?: string[]
}

export type DigitalAssetsState = {
  items: Dict<DigitalAsset>
  meta: Dict<EntityMetadata<DigitalAsset>>
  ids: string[]
  listFetchProgress: Progress
  listFetchError: FetchError | null
  listFetchNextProgress: Progress
  listFetchNextError: FetchError | null
  itemFetchProgress: Progress
  itemFetchError: FetchError | null
  addProgress: Progress
  addError: AddError | null
  addErrorDetail: string
  updateProgress: Progress
  updateError: UpdateError | null
  updateErrorDetail: string
  removeProgress: Progress
  removeError: RemoveError | null
  itemMetaDataFetchProgress: Progress
  itemMetaDataFetchError: FetchError | null

  filter: DigitalAssetListRequestFilter
  sorting: DigitalAssetListRequestSorting
  page: number
  total: number
  pageSize: number
  drafts: DraftDigitalAsset[]
  uploadCompanyType: UploadCompanyType
}

export type DraftDigitalAsset = {
  id: string
  asset_type?: AssetType
  name?: string
}

export type DigitalAssetListResponse = {
  total_count: number
  data: DigitalAsset[]
}

export type DigitalAssetComment = {
  id: string
  created_at: string
  comment_text: string
}

export type DigitalAssetActivity = {
  id: string
  created_at: string
  activity_text: string
}
